var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoOffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7013 15.4563C14.0578 15.0764 14.286 14.5941 14.3538 14.0775L18.2413 15.805C18.4315 15.8898 18.64 15.9257 18.8477 15.9094C19.0554 15.8931 19.2557 15.8252 19.4304 15.7118C19.6052 15.5984 19.7488 15.4431 19.8483 15.2601C19.9478 15.0771 19.9999 14.8721 20 14.6638V5.33626C19.9998 5.12811 19.9477 4.92329 19.8483 4.74041C19.7488 4.55752 19.6053 4.40236 19.4308 4.28899C19.2562 4.17563 19.0561 4.10766 18.8486 4.09124C18.641 4.07483 18.4327 4.1105 18.2425 4.19501L14.3538 5.92251C14.2743 5.32137 13.9791 4.76959 13.5231 4.36992C13.0671 3.97025 12.4814 3.74994 11.875 3.75001H5.34L13.7025 15.4563H13.7013ZM1.05875 4.20626C0.731527 4.43726 0.464566 4.74346 0.280322 5.09912C0.096079 5.45477 -5.75179e-05 5.84947 2.58174e-08 6.25001V13.75C2.58174e-08 14.4131 0.263392 15.0489 0.732233 15.5178C1.20107 15.9866 1.83696 16.25 2.5 16.25H9.66L1.05875 4.20751V4.20626ZM13.2413 19.1125L0.74125 1.61251L1.75875 0.887512L14.2587 18.3875L13.2413 19.1125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOffIcon);
export default __webpack_public_path__ + "static/media/video-off-icon.b0f87447321113bdf198c5379c515284.svg";
export { ForwardRef as ReactComponent };